import { getWebSessionToken } from './webSessionAuth';
import { getNativeIosLinkedUser } from './nativeApiRouting';
import { hostWebApp } from './hostWebApp';

const listeners = new Set<() => void>();
let state = { eligible: false, enabled: false };
let verifiedSession = '';

function sessionKey(): string {
  const native = getNativeIosLinkedUser();
  return getWebSessionToken() || hostWebApp.getInitData?.() || native?.sessionToken || '';
}
function emit() { for (const listener of listeners) listener(); }
export function isDriverGpsTestEligible(): boolean {
  return state.eligible && Boolean(verifiedSession) && verifiedSession === sessionKey();
}
export function isDriverGpsTestEnabled(): boolean {
  return isDriverGpsTestEligible() && state.enabled;
}
export function driverGpsTestHeaders(): Record<string, string> {
  return isDriverGpsTestEnabled() ? { 'X-ZiaWellNav-Gps-Test': '1' } : {};
}
export const driverGpsTest = {
  subscribe(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; },
  snapshot: () => state,
  async refresh(headers: HeadersInit): Promise<void> {
    const session = sessionKey();
    if (session !== verifiedSession) {
      state = { eligible: false, enabled: false };
      verifiedSession = '';
      emit();
    }
    if (!session) return;
    try {
      const response = await fetch('/api/driver-gps-test', { headers, cache: 'no-store' });
      const data = await response.json();
      if (session !== sessionKey()) return;
      const eligible = response.ok && data.eligible === true;
      verifiedSession = eligible ? session : '';
      state = { eligible, enabled: eligible && state.enabled };
    } catch { state = { eligible: false, enabled: false }; verifiedSession = ''; }
    emit();
  },
  toggle() {
    if (!state.eligible || !verifiedSession || verifiedSession !== sessionKey()) return;
    state = { ...state, enabled: !state.enabled };
    emit();
  },
};
